import { IonSpinner } from '@ionic/react'
import { observer } from 'mobx-react'
import React from 'react'
import { EmptyPage } from '../../common'
import { SingleSubStore } from '../../store/subStore'

type DetailContentProps = {
  detailStore: SingleSubStore<any>
}

export const DetailContent: React.FC<DetailContentProps> = observer(({ detailStore, children }) => {
  let appendLoadRendering

  if (detailStore.isFailed) {
    appendLoadRendering = <EmptyPage icon={'warning'} content={'오류가 발생했습니다. 다시 시도해주세요'} />
  } //
  else if (detailStore.isLoading) {
    appendLoadRendering = (
      <div style={{ display: 'flex', justifyContent: 'center', height: '117px', alignItems: 'center' }}>
        <IonSpinner color={'medium'} name="dots" />
      </div>
    )
  } //
  return (
    <>
      {children}
      {appendLoadRendering}
    </>
  )
})
